import React, { useEffect, useState } from 'react';
import InfoIconSolid from "assets/img/svg/svgComponents/InfoIconSolid";
import CrossIcon from "assets/img/svg/svgComponents/CrossIcon";

const defaultBannerStyles = {
    display: 'flex',
    justifyContent: 'space-between',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 600,
    gap : '0.5rem',
    padding: '0.5rem 0.75rem',
    width: "100%"
}



const ABanner = ({
    msg,
    isShow,
    txtColor = "#07794C",
    bgColor = "#E6F4ED",
    style = {},
    infoIcon = InfoIconSolid,
    ...rest
}) => {

    const [showBanner, setShowBanner] = useState(isShow);

    useEffect(() => {
        setShowBanner(isShow);
    }, [isShow])

    return (
        showBanner && <div
            style={{ ...defaultBannerStyles, backgroundColor: bgColor, color: txtColor, ...style }}
            {...rest}
        >
            <div className='d-flex justify-content-center align-items-center' style={{ flexGrow: 2, gap: '0.5rem'}}>
                {/* <InfoIconSolid color={txtColor} /> */}
                {React.createElement(infoIcon, {color : txtColor})}
                <span>{msg}</span>
            </div>

            <span onClick={() => setShowBanner(false)} className="cursor"><CrossIcon color={txtColor} /></span>
        </div>
    );
}

export default ABanner;